import ROOTURL from "../ROOTURL";
import axios from "axios"

//Products APIs
export const createOrder = (object) => axios.post(`${ROOTURL}/sale`, object)

export const createTransaction = (object) => axios.post(`${ROOTURL}/transactions`, object)